import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Text from '#components/a/Text'
import Headline from '#components/a/Headline'
import AusbildungsplanHeaderModal from './AusbildungsplanHeaderModal'

function EinreichenButton(props) {
  const {disabled, submit} = props
  return (
    <AusbildungsplanHeaderModal
      id="kapitel_einreichen_button"
      trigger={i18n.t('kapitel_einreichen_button')}
      variant="primary"
      modifiers={['einreichen']}
      confirmCallback={submit}
      confirmText={i18n.t('kapitel_einreichen_button')}
      disabled={disabled}
    >
      <Headline modifier="article" importance={2} text={i18n.t('kapitel_einreichen_modal_header')} />
      <Text modifier="small" text={i18n.t('kapitel_einreichen_modal_text')} />
    </AusbildungsplanHeaderModal>
  )
}

EinreichenButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
}

export default EinreichenButton
